var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.53,
    height: 14.53,
    viewBox: "0 0 14.53 14.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3e3e3e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.733,5.687l-1.138-.145a5.722,5.722,0,0,0-.344-.832l.7-.905a.9.9,0,0,0-.074-1.2l-.954-.954a.9.9,0,0,0-1.2-.077l-.9.7a5.7,5.7,0,0,0-.832-.344L8.843.8a.907.907,0,0,0-.9-.8H6.587a.907.907,0,0,0-.9.8L5.543,1.936a5.635,5.635,0,0,0-.832.344l-.9-.7a.9.9,0,0,0-1.2.074L1.654,2.6a.9.9,0,0,0-.077,1.2l.7.9a5.655,5.655,0,0,0-.344.832L.8,5.687a.907.907,0,0,0-.8.9V7.943a.907.907,0,0,0,.8.9l1.138.145a5.721,5.721,0,0,0,.344.832l-.7.905a.9.9,0,0,0,.074,1.2l.954.954a.9.9,0,0,0,1.2.076l.9-.7a5.589,5.589,0,0,0,.832.344l.145,1.136a.907.907,0,0,0,.9.8H7.943a.907.907,0,0,0,.9-.8l.145-1.138a5.722,5.722,0,0,0,.832-.344l.905.7a.9.9,0,0,0,1.2-.074l.954-.954a.9.9,0,0,0,.077-1.2l-.7-.9a5.59,5.59,0,0,0,.344-.832l1.136-.145a.907.907,0,0,0,.8-.9V6.587a.906.906,0,0,0-.8-.9Zm-6.468,4.6a3.027,3.027,0,1,1,3.027-3.027,3.031,3.031,0,0,1-3.027,3.027Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.7deef81202e170ef972beaae4ce9cc98.svg";
export { ForwardRef as ReactComponent };